/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DivideCircleIcon24Regular = forwardRef('DivideCircleIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M7.5 11.25a.75.75 0 0 0 0 1.5h9a.75.75 0 0 0 0-1.5h-9Z" }),
        React.createElement("path", { d: "M13.25 7.748a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0Z" }),
        React.createElement("path", { d: "M12 17.502a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25ZM3.75 12a8.25 8.25 0 1 1 16.5 0 8.25 8.25 0 0 1-16.5 0Z" })));
});
